import { getContrastRatio } from "@material-ui/core";
/* -------------------------------------------------------------------------- */
export function getContrastText(background = "#000000") {
  // Function to calculate the relative luminance of a color
  const contrast = getContrastRatio(background, "#000000");
  // Determine the appropriate text color based on contrast ratio
  const textColor = contrast > 7 ? "#000000" : "#FFFFFF";

  return textColor;
}
